import { createFileRoute } from "@tanstack/react-router";

import { SKUStoreCopyPage } from "@/features/SKUStore/SKUStoreCopyPage";

export const Route = createFileRoute("/_auth/sku-store/$siteId/$skuId/copy")({
  component: SKUStoreCopyPage,
});
